<script setup>
import { defineAsyncComponent } from 'vue'
import { RouterView } from 'vue-router'
import NotificationPoint from '@/components/utility/NotificationPoint.vue'

const DevTimeIndicator = import.meta.env.DEV
  ? defineAsyncComponent(() => import('@/components/dev/DevTimeIndicator.vue'))
  : null
</script>

<template>
  <component :is="DevTimeIndicator" v-if="DevTimeIndicator" />
  <notification-point />
  <router-view />
</template>
